import { useMemo } from "react";
import { createApi } from "./api";
import { TopBar } from "./components/TopBar";
import { DeadLinkScreen } from "./screens/StateScreen";
import { SignerApp } from "./SignerApp";

/** The one route: /s/{token}. Anything else is the same neutral page as a dead link. */
export function tokenFrom(pathname: string): string | null {
  const m = /^\/s\/([^/]+)\/?$/.exec(pathname);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]!);
  } catch {
    return null;
  }
}

export function App() {
  const token = tokenFrom(window.location.pathname);
  const search = window.location.search;
  const api = useMemo(() => (token ? createApi(token, search) : null), [token, search]);
  if (!api) {
    return (
      <div className="app">
        <TopBar sender={null} stepIndex={null} />
        <DeadLinkScreen />
      </div>
    );
  }
  return <SignerApp api={api} />;
}
